__turbopack_context__.v({
  "header": "styles-module__qjilNq__header",
  "header--large": "styles-module__qjilNq__header--large",
  "header--small": "styles-module__qjilNq__header--small",
});
